var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"print"}},_vm._l((_vm.orders),function(order){return _c('section',{key:order.id,staticClass:"print-orders"},[_c('order-print-item',{attrs:{"order":order,"settings":_vm.settings}})],1)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }